import {
  PRICE_POLICIES_UPDATE_BONIFICATIONS_BEGIN,
  PRICE_POLICIES_UPDATE_BONIFICATIONS_SUCCESS,
  PRICE_POLICIES_UPDATE_BONIFICATIONS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case PRICE_POLICIES_UPDATE_BONIFICATIONS_BEGIN:
      return {
        ...state,
        bonificationsPending: true,
        bonificationsError: false
      }
    case PRICE_POLICIES_UPDATE_BONIFICATIONS_SUCCESS:
      return {
        ...state,
        bonificationsPending: false,
        bonificationsError: false,
        bonificationsSuccess: action.data.bonificationsSuccess
      }
    case PRICE_POLICIES_UPDATE_BONIFICATIONS_FAILURE:
      return {
        ...state,
        bonificationsPending: false,
        bonificationsError: action.data.bonificationsError
      }
    default:
      return state
  }
}
